import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditResidencePage = {
  alert: {
    error: 'applicant-edit-residence.alert.error',
  },
  footer: {
    root: 'applicant-edit-residence.footer.root',
  },
  form: {
    addressLine1Input: 'applicant-edit-residence.form.address-line-1-input',
    addressLine1InputError:
      'applicant-edit-residence.form.address-line-1-input-error',
    addressLine2Input: 'applicant-edit-residence.form.address-line-2-input',
    amountInput: 'applicant-edit-residence.form.amount-input',
    amountInputError: 'applicant-edit-residence.form.amount-input-error',
    cancelButton: 'applicant-edit-residence.form.cancel-button',
    cityInput: 'applicant-edit-residence.form.city-input',
    cityInputError: 'applicant-edit-residence.form.city-input-error',
    h1: 'applicant-edit-residence.form.h1',
    h2: 'applicant-edit-residence.form.h2',
    monthSelect: 'applicant-edit-residence.form.month-select',
    monthSelectError: 'applicant-edit-residence.form.month-select-error',
    previousAddressLine1Input:
      'applicant-edit-residence.form.previous-address-line-1-input',
    previousAddressLine1InputError:
      'applicant-edit-residence.form.previous-address-line-1-input-error',
    previousAddressLine2Input:
      'applicant-edit-residence.form.previous-address-line-2-input',
    previousCityInput: 'applicant-edit-residence.form.previous-city-input',
    previousCityInputError:
      'applicant-edit-residence.form.previous-city-input-error',
    previousResidenceRoot:
      'applicant-edit-residence.form.previous-residence-root',
    previousStateSelect: 'applicant-edit-residence.form.previous-state-select',
    previousStateSelectError:
      'applicant-edit-residence.form.previous-state-select-error',
    previousZipCodeInput:
      'applicant-edit-residence.form.previous-zip-code-input',
    previousZipCodeInputError:
      'applicant-edit-residence.form.previous-zip-code-input-error',
    residenceTypeSelect: 'applicant-edit-residence.form.residence-type-select',
    residenceTypeSelectError:
      'applicant-edit-residence.form.residence-type-select-error',
    root: 'applicant-edit-residence.form.root',
    stateSelect: 'applicant-edit-residence.form.state-select',
    stateSelectError: 'applicant-edit-residence.form.state-select-error',
    submitButton: 'applicant-edit-residence.form.submit-button',
    zipCodeInput: 'applicant-edit-residence.form.zip-code-input',
    zipCodeInputError: 'applicant-edit-residence.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'applicant-edit-residence.header.drawer-button',
    previousStepButton: 'applicant-edit-residence.header.previous-step-button',
    root: 'applicant-edit-residence.header.root',
  },
  progress: {
    root: 'applicant-edit-residence.progress.root',
  },
} as const satisfies PageLocatorMap;
